"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchCustomEvent = exports.isNode = void 0;
const isNode = () => {
    return typeof window === 'undefined';
};
exports.isNode = isNode;
const dispatchCustomEvent = (type, detail) => {
    return (0, exports.isNode)() ? () => true : window.dispatchEvent(new CustomEvent(type, detail));
};
exports.dispatchCustomEvent = dispatchCustomEvent;
//# sourceMappingURL=dispatch-custom-event.js.map